import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { getWithdrawals, merchantWithdrawal } from "./slice";
import { WithdrawalForm, WithdrawalParameters } from "./api";

export const useWithdrawals = () => {
  const userId = useUserId();
  const state = useAppSelector((state) => state.withdrawals);
  const dispatch = useAppDispatch();

  const getWithdrawalsHandler = useCallback(
    (data?: WithdrawalParameters) => dispatch(getWithdrawals({ userId, data })),
    [dispatch, userId]
  );

  const merchantWithdrawalHandler = useCallback(
    (data: WithdrawalForm) =>
      dispatch(merchantWithdrawal({ userId, data })).unwrap(),
    [dispatch, userId]
  );

  return {
    state,
    getWithdrawals: getWithdrawalsHandler,
    merchantWithdrawal: merchantWithdrawalHandler,
  };
};
